import { render, staticRenderFns } from "./WalletBadge.vue?vue&type=template&id=a160afc8&scoped=true&"
import script from "./WalletBadge.vue?vue&type=script&lang=js&"
export * from "./WalletBadge.vue?vue&type=script&lang=js&"
import style0 from "./WalletBadge.vue?vue&type=style&index=0&id=a160afc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a160afc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
